"use client";
import { useActionState, useState } from "react";
import { login } from "@/app/login/actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
export function LoginForm() {
 const [username,setUsername]=useState("");
 const [state,action,pending]=useActionState(login,{error:""});
 return <form action={action} className="space-y-5">
  <div className="space-y-2"><Label htmlFor="username">帳號</Label><Input id="username" name="username" value={username} onChange={event=>setUsername(event.target.value)} autoComplete="username" required /></div>
  <div className="space-y-2"><Label htmlFor="password">密碼</Label><Input id="password" name="password" type="password" autoComplete="current-password" required /></div>
  {state.error && <p role="alert" className="text-body text-destructive">{state.error}</p>}
  <Button type="submit" className="w-full" disabled={pending}>{pending?"登入中…":"登入"}</Button>
 </form>;
}
